import { SEVERITY_TYPES } from '../alerts/constants'
import { COMPLETE_REQUEST_EXECUTION_STATUS, COMPLETE_REQUEST_STATUSES, COMPLETE_REQUEST_TYPES } from './constants'

export default {
  getCompleteRequestStatus() {
    return status => {
      return (
        COMPLETE_REQUEST_STATUSES[status] ?? {
          title: status,
          color: COMPLETE_REQUEST_STATUSES.initial.color
        }
      )
    }
  },
  getCompleteRequestType() {
    return type => {
      return (
        COMPLETE_REQUEST_TYPES[type] ?? {
          title: type,
          color: COMPLETE_REQUEST_TYPES.document.color
        }
      )
    }
  },
  getCompleteRequestSeverity() {
    return severity => {
      return (
        SEVERITY_TYPES[severity] ?? {
          title: severity,
          color: SEVERITY_TYPES.normal.color
        }
      )
    }
  },
  getCompleteRequestExecution() {
    return status => {
      return (
        COMPLETE_REQUEST_EXECUTION_STATUS[status] ?? {
          title: status,
          color: COMPLETE_REQUEST_EXECUTION_STATUS.initial.color
        }
      )
    }
  }
}
